import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${spacers?.spacers?.[2]};
`;

export const ControlledPanel = styled.div`
  padding-block-end: ${spacers?.spacers?.[4]};
  inline-size: 100%;
`;
